import { Injectable } from '@angular/core';
import { Subject, Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionService } from '../app-user-session.service';
import { HttpGeneralService } from './http-general.service';
import { CONFIG } from './config';
let stockTransUrl = CONFIG.baseUrls.StockTrans;
@Injectable({
  providedIn: 'root'
})
export class GenModuleSettingService {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private httpGeneralService: HttpGeneralService, private _USS: UserSessionService) { }
  getStockModuleSettings(parms: any): Observable<any> {
    let stockModuleSettings: any = [];
    if (this._USS.getSessionKey('modulesSettings')) {
      this._USS.subscribeToKey$('modulesSettings')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((keys: any) => {
          if (keys.value && keys.value[`m_${parms.moduleId}`]) {
            stockModuleSettings.push(keys.value[`m_${parms.moduleId}`]);
          }
        });
      if (stockModuleSettings.length > 0) {
        let settingsObj = stockModuleSettings[0]; // Access the first object in the array
        let newObj = {}; // Create a new object to store unique keys
        let usedKeys = new Set(); // To track used keys based on the first character
      
        // Loop through the object keys
        for (let key in settingsObj) {
          if (settingsObj.hasOwnProperty(key)) {
            // Determine the first character
            let firstChar = key.charAt(0).toLowerCase();
      
            // Create new keys for both capitalized and lowercase first characters
            let capitalizedKey = firstChar.toUpperCase() + key.slice(1);
            let lowercaseKey = firstChar + key.slice(1);
       
              newObj[key] = settingsObj[key];
              newObj[capitalizedKey] = settingsObj[key];
              newObj[lowercaseKey] = settingsObj[key];
              usedKeys.add(firstChar); 
          }
        }
      
        console.log("Module Setting = ", [newObj]);
        return of({ data: [newObj] });
      } else {
        return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
      }
    } else {
      return this.httpGeneralService.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
    }

  }
}
